import { getLanguage } from 'frontcore/i18n'
import { getScores, getTemplate, getTemplates } from 'frontend/communications/templates'


const stateObj = {
  templates: {},
  auditActiveTemplates: {},
  auditActiveTemplatesPromise: null,
  scoresPromise: null,
  scores: [],
}

const getters = {
  templates (state) {
    return state.templates
  },
  getActiveTemplateById: (state) => (id) => {
    if (!state.auditActiveTemplatesPromise) {
      console.error("Fetch active templates first")
    }
    return state.templates[id]
  },
  getAuditActiveTemplate: (state) => (source) => {
    if (!state.auditActiveTemplatesPromise) {
      console.error("Fetch active templates first")
    }
    return state.auditActiveTemplates[source]
  },
  getScores (state) {
    if (!state.scores) {
      console.error("Fetch scores for templates first")
    }
    return state.scores
  },
}

const mutations = {
  setAuditActiveTemplate (state, template) {
    state.auditActiveTemplates[template.source] = template
    Object.values(state.templates)
      .filter(elem => elem.source === template.source && elem.id != template.id)
      .forEach(elem => {
        elem.active = false 
      })
  },
  addTemplate (state, template) {
    state.templates[template.id] = template
  },
  setScores (state, scores) {
    state.scores = scores
  },
}

const actions = {
  async fetchTemplate ({ commit, state }, templateId) {
    if (templateId in state.templates) {
      return state.templates[templateId]
    }
    const data = await getTemplate(templateId)
    const template = getTemplateFromData([data])
    commit('addTemplate', template)
    return template
  },
  async fetchActiveTemplates ({ commit, state }, {force = false, source = ''} = {}) {
    const requestedSources = Object.keys(state.auditActiveTemplates)
    const needToRequestTemplates = requestedSources.length === 0 || (source !== '' && !requestedSources.includes(source))
    if (state.auditActiveTemplatesPromise == null || force || needToRequestTemplates) {
      state.auditActiveTemplatesPromise = getTemplates({ source: source, active: true })
    }
    try {
      const data = await state.auditActiveTemplatesPromise
      if (force || needToRequestTemplates) {
        data.forEach((element) => {
          const templateRaw = data.filter((item) => { return item.source === element.source })
          commit('setAuditActiveTemplate', getTemplateFromData(templateRaw))
        })
      }
      return data
    } catch(e) {
      state.auditActiveTemplatesPromise = null
      throw e
    }
  },
  fetchScores ({ commit, state }) {
    if (state.scoresPromise == null) {
      state.scoresPromise = getScores()
    }
    return state.scoresPromise.then(data => {
      commit('setScores', getFormattedScores(data))
    }).catch(e => {
      state.scoresPromise = null
      throw e
    })
  },
}

function getFormattedScores (data) {
  const language = getLanguage()
  return data.map((item) => {
    return {
      id: item.id,
      image_name: item.image_name,
      text: item.texts[language],
      source: item.source,
    }
  })
}

function getTemplateFromData (data) {
  const language = getLanguage()
  return data.map((template) => {
    return getTemplateData(template, language)
  })[0]
}

export function getTemplateData (template, language) {
  return {
    id: template.id,
    date: template.created,
    active: template.active,
    name: template.name,
    source: template.source,
    assessmentType: template.assessment_type,
    criteria: template.criteria.map((criterion) => {
      return {
        id: criterion.id,
        order: criterion.order,
        template_level_item: criterion.template_level_item,
        text: criterion.texts[language] ?? criterion.title,
        hint: criterion.hints[language],
        title: criterion.title,
        subtitle: criterion.subtitle,
        compliances_cases: criterion.compliances_cases,
        assessmentType: criterion.assessment_type,
      }
    }),
    templateLevels: template.levels.map((level) => {
      return {
        id: level.id,
      }
    }),
    templateLevelItems: template.levels.length === 0 ? [] : template.levels[0].items.map((item) => {
      return {
        id: item.id,
        order: item.order,
        text: item.texts[language],
        hasComments: item.has_comments,
      }
    }),
    scores: template.scores.map((score) => {
      return {
        image: score.image_name,
        legend: score.texts[language],
        value: score.value,
      }
    }),
    need_signature: template.need_signature,
  }

}

export default {
  state: stateObj,
  getters,
  mutations,
  actions,
}
